import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENDPOINTS } from '@shared/constants';
import {
  CommonResponseDTO,
  IApiKey,
  IPublicKeyResponse,
} from '@shared/interfaces';
import { generateURL } from '@shared/utils';

@Injectable({
  providedIn: 'root',
})
export class AgentsKeysService {
  constructor(private http: HttpClient) {}

  generatePublicApiKey(): Observable<CommonResponseDTO<IPublicKeyResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.AGENTS_GENERATE_PUBLIC_API_KEY,
    });
    return this.http.get<CommonResponseDTO<IPublicKeyResponse>>(url);
  }

  saveGeneratedPublicApiKey(
    apiKey: string,
    reference: string
  ): Observable<CommonResponseDTO<IPublicKeyResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.AGENTS_SAVE_GENERATED_API_KEY,
    });
    return this.http.post<CommonResponseDTO<IPublicKeyResponse>>(url, {
      apiKey,
      reference,
    });
  }

  getGeneratedKey(
    id: string
  ): Observable<CommonResponseDTO<IPublicKeyResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.AGENTS_GET_SPECIFIC_GENERATED_KEY,
      params: { id },
    });
    return this.http.get<CommonResponseDTO<IPublicKeyResponse>>(url);
  }

  getGeneratedKeys(): Observable<CommonResponseDTO<IApiKey[]>> {
    const url = generateURL({
      endpoint: ENDPOINTS.AGENTS_GET_ALL_GENERATED_KEYS,
    });
    return this.http.get<CommonResponseDTO<IApiKey[]>>(url);
  }

  deleteKey(id: string): Observable<CommonResponseDTO<IApiKey>> {
    const url = generateURL({
      endpoint: ENDPOINTS.AGENTS_DELETE_KEY,
      params: { id },
    });
    return this.http.delete<CommonResponseDTO<IApiKey>>(url);
  }

  restoreKey(id: string): Observable<CommonResponseDTO<IApiKey>> {
    const url = generateURL({
      endpoint: ENDPOINTS.AGENTS_RESTORE_KEY,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IApiKey>>(url, {});
  }
}
